export default "__VITE_ASSET__I6jz6SN6__"